export const ONBOARDING_POPULAR_FEED_CARD_SEEN_KEY = 'onboarding-popular-feed-card:isDismissed';

export const FeedOnboardingKeys: readonly ['onboarding-popular-feed-card:isDismissed'] = [
	ONBOARDING_POPULAR_FEED_CARD_SEEN_KEY,
] as const;
